const commonSchema = [
	{ field: 'appointmentId', label: 'ID', forDisplay: false },
	{ field: 'type', label: 'Type' },
	{ field: 'description', label: 'Description' },
	{ field: 'team', label: 'Team' },
	{ field: 'code', label: 'Code' },
	{ field: 'appointee.name', label: 'Name' },
	{ field: 'appointee.ni', label: 'NI' },
	{ field: 'template', label: 'Template' },
	{ field: 'readyForApproval', label: 'Ready for Approval' },
	{ field: 'contract.releaseDate', label: 'Contract Release Date', type: 'date' },
	{ field: 'contract.endDate', label: 'Contract End Date', type: 'date' },
	{ field: 'teamEmail', label: 'Team Email', className: 'team-email' },
];

const invigilatorSchema = [
    { field: 'notes', label: 'Invigilator Position', type: 'number' }
];

const verifierSchema = [
    { field: 'notes', label: 'Approved Verification Level' }
];

const othersSchema = [
    { field: 'notes', label: 'Notes' }
];

const commonFields = [
    { name: 'template', label: 'Template', type: 'list', allowEmpty: true },
    { name: 'readyForApproval', label: 'Ready for Approval', type: 'list' },
    { name: 'appointee.ni', label: 'NI', type: 'text' },
    { name: 'team', label: 'Team Name contains', type: 'text' },
];

const invigilatorFields = [
    { name: 'notes', label: 'Invigilator Position', type: 'number-select' },
];

const verifierFields = [
    { name: 'notes', label: 'Approved Verification Level', type: 'list', allowEmpty: true },
];

const othersFields = [
    { name: 'notes', label: 'Notes', type: 'text' },
];

export { commonSchema, invigilatorSchema, verifierSchema, othersSchema, commonFields, invigilatorFields, verifierFields, othersFields };